import {
  TabbedForm,
  FormTab,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  NumberInput,
  LongTextInput
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { typeService } from "../../constant/TypeService";
import { SUPERADMIN } from "../../constant/TypeRole";

class ServiceForm extends React.Component {
  state = {
    type: this.props.record.type || null
  };
  render() {
    const props = this.props;
    const { type } = this.state;
    const role = localStorage.getItem("role");
    const project = JSON.parse(localStorage.getItem("project"));
    const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
    return (
      <TabbedForm {...props}>
        <FormTab label="service.tab.general">
          <ReferenceInput
            disabled={props.record.project ? true : false}
            validate={[required()]}
            source="project"
            reference="project"
            filter={filter}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput source="name" validate={[required()]} />
          <SelectInput
            disabled={props.record.type ? true : false}
            validate={[required()]}
            source="type"
            choices={typeService}
            onChange={(event, key, payload) => this.setState({ type: key })}
          />
          {(type === 1 || type === 2 || type === 3) && (
            <TextInput fullWidth source="url" validate={[required()]} />
          )}
          {(type === 1 || type === 2 || type === 3) && (
            <ImageInput
              multiple={false}
              validate={[required()]}
              source="image"
              accept="image/*"
            >
              <ImageField source="url" title="name" />
            </ImageInput>
          )}
          {type === 4 && <TextInput source="tel" validate={[required()]} />}
          {type === 4 && (
            <div style={{ display: "flex" }}>
              <div>
                <TextInput
                  label="Latitude"
                  source="location[0]"
                  validate={[required()]}
                />
              </div>
              &nbsp;
              <div>
                <TextInput
                  label="Longitude"
                  source="location[1]"
                  validate={[required()]}
                />
              </div>
            </div>
          )}
        </FormTab>
        <FormTab label="service.tab.invoice">
          <LongTextInput source="invoice_to" />
          <LongTextInput source="invoice_company" />
          <LongTextInput source="invoice_address" />
          <NumberInput source="price" />
        </FormTab>
      </TabbedForm>
    );
  }
}

export default ServiceForm;



// WEBPACK FOOTER //
// ./src/components/service/ServiceForm.js